import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import { useAlita } from 'redux-alita';
import umbrella from 'umbrella-storage';
import AllComponents from '../components';
import routesConfig, { IFMenuBase, IFMenu } from './config';
import { checkLogin } from '../utils';
import RouteWrapper from './RouteWrapper';

type CRouterProps = {
    auth: any;
};

const CRouter = (props: CRouterProps) => {
    const { auth } = props;
    const [smenus] = useAlita({ smenus: null }, { light: true });

    const getPermits = (): any[] | null => {
        return auth ? auth.permissions : null;
    };
    const requireAuth = (permit: any, component: React.ReactElement) => {
        const permits = getPermits();
        if (!permits || !permits.includes(permit)) return <Redirect to={'404'} />;
        return component;
    };
    const requireLogin = (component: React.ReactElement, permit: any) => {
        if (!checkLogin()) {
            return <Redirect to={'/login'} />;
        }
        return permit ? requireAuth(permit, component) : component;
    };
    const createMenu = (r: IFMenu) => {
        const route = (r: IFMenuBase) => {
            const Component = r.component && AllComponents[r.component];
            return (
                <Route
                    key={r.route || r.key}
                    exact
                    path={r.route || r.key}
                    render={(props: any) => {
                        // 重新包装组件
                        const wrapper = (
                            <RouteWrapper {...{ ...props, Comp: Component, route: r }} />
                        );
                        return r.login ? wrapper : requireLogin(wrapper, r.requireAuth);
                    }}
                />
            );
        };

        const subRoute = (r: IFMenu): any =>
            r.subs && r.subs.map((subR: IFMenu) => (subR.subs ? subRoute(subR) : route(subR)));

        return r.component ? route(r) : subRoute(r);
    };
    const createRoute = (key: string) => routesConfig[key].map(createMenu);
    const getAsyncMenus = () => smenus || umbrella.getLocalStorage('smenus') || [];

    if (Array.isArray(getAsyncMenus)) {
        return (
            <Switch>
                {Object.keys(routesConfig).map((key) => createRoute(key))}
                {getAsyncMenus().map(createMenu)}
                <Route render={() => <Redirect to={checkLogin() ? '/404' : '/login'} />} />
            </Switch>
        );
    } else {
        // console.log('getAsyncMenus(...) 返回的值不是一个数组');
        return (
            <Switch>
                {Object.keys(routesConfig).map((key) => createRoute(key))}
                <Route render={() => <Redirect to={checkLogin() ? '/404' : '/login'} />} />
            </Switch>
        );
    }
};

export default CRouter;
